import React, { useState } from 'react';
import propTypes from 'prop-types';
;
import classNames from 'classnames';
import { SaveChangesToast, ConfirmChangesModal } from 'src/ui';
import { InsuranceInformationForm } from './InsuranceInformationForm';
import { LicenseProfileForm } from './LicenseProfileForm';
import { BadgeList } from './BadgeList';
import { PersonAddressForm } from './PersonAddressForm';
import { AddressForm } from './AddressForm';
import { Tabs, TabList, Tab, TabLink } from 'src/ui/mui-ui-kit'

const tabs = [
  {
    id: 'personal',
    label: 'Person Profile',
    component: InsuranceInformationForm,
  },
];

export function InsurancePersonProfileForm({
  onSubmit,
  submitting,
  hasValidationErrors,
  isDirty,
  isExpanded,
  showBadges,
  ...props
}) {
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [confirmChangesModal, setConfirmChangesModal] = useState(false);
  const toastContainerClassName = classNames('bottom-toast-container', {
    'is-condensed': !isExpanded,
  });
  const badgesTab = tabs.find(tab => tab.id === 'badges');

  const showModal = React.useCallback(() => {
    setConfirmChangesModal(true);
  }, [setConfirmChangesModal]);

  const hideModal = React.useCallback(() => {
    setConfirmChangesModal(false);
  }, [setConfirmChangesModal]);

  return (
    <form onSubmit={onSubmit} noValidate>
      <div className={toastContainerClassName}>
        <SaveChangesToast
          message="Click the button to the right to save your changes"
          isLoading={submitting}
          isDisabled={submitting || hasValidationErrors}
          isVisible={isDirty}
          onClickButton={showModal}
        />
      </div>
      <ConfirmChangesModal
        title="Person Profile"
        isActive={confirmChangesModal}
        onClickCancel={hideModal}
        onClickSubmit={hideModal}
      />
      <Tabs isToggle>
        <TabList>
          {tabs.map(tab => {
            const result = (
              <Tab isActive={activeTab === tab.id} key={tab.id}>
                <TabLink onClick={() => setActiveTab(tab.id)}>
                  {tab.label}
                </TabLink>
              </Tab>
            );
            if (tab.id !== 'badges' || (tab.id === 'badges' && showBadges)) {
              return result;
            }
            return null;
          })}
        </TabList>
      </Tabs>
      {tabs
        .filter(tab => tab.id !== 'badges')
        .map(tab => {
          const TabComponent = tab.component;
          const className = tab.id === activeTab ? '' : 'is-hidden';

          return (
            <TabComponent
              {...props}
              className={className}
              key={tab.id}
              readyToSubmit={hasValidationErrors}
            />
          );
        })}
      {activeTab === 'badges' && <badgesTab.component {...props} />}
    </form>
  );
}

InsurancePersonProfileForm.propTypes = {
  onSubmit: propTypes.func.isRequired,
  submitting: propTypes.bool.isRequired,
  hasValidationErrors: propTypes.bool.isRequired,
  isDirty: propTypes.bool.isRequired,
  isExpanded: propTypes.bool.isRequired,
  showBadges: propTypes.bool.isRequired,
  ...InsuranceInformationForm.propTypes,
  ...LicenseProfileForm.propTypes,
  ...PersonAddressForm.propTypes,
  ...AddressForm.propTypes,
  ...BadgeList.propTypes,
};
